var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{staticStyle:{"margin":"0 10px"},attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.openDialogPhoto()}}},[_vm._v("拍照生成PDF")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }